import React from 'react';
import PropTypes from 'prop-types';

import LeaseFilters from './lease_filters';
import SaleFilters from './sale_filters';

export default function CompSelectorSidebar({ query, type, onChange }) {
  const TypeFilters = type === 'lease' ? LeaseFilters : SaleFilters;

  return (
    <div className="comp-selector-filters" style={{ minWidth: 240 }}>
      <TypeFilters query={query} onChange={onChange} />
    </div>
  );
}

CompSelectorSidebar.propTypes = {
  query: PropTypes.object,
  type: PropTypes.oneOf(['lease', 'sale']).isRequired,
  onChange: PropTypes.func,
};
